import { render } from "./PosComponent.vue?vue&type=template&id=7a8fd462"
import script from "./PosComponent.vue?vue&type=script&lang=js"
export * from "./PosComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/admin/pos/PosComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7a8fd462"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7a8fd462', __exports__)) {
    api.reload('7a8fd462', __exports__)
  }
  
  module.hot.accept("./PosComponent.vue?vue&type=template&id=7a8fd462", () => {
    api.rerender('7a8fd462', render)
  })

}


export default __exports__